import styles from './PlumXLogo.module.scss';

interface PlumXLogoProps {
  variant?: 'white' | 'color';
  size?: 'sm' | 'md';
}

const PlumXLogo = ({ variant = 'color', size = 'md' }: PlumXLogoProps) => {
  return (
    <span className={[styles.logo, styles[variant], styles[size]].join(' ')}>
      <svg className={styles.icon} viewBox="45 205 235 350" aria-hidden="true">
        <g className={styles.plumBody} transform="translate(406.941 372.6443)">
          <path d="M-274.9,138.5c-3.5-3-6.7-6.3-9.5-9.9c-5.1-6.7-9.4-14.3-12.9-22.6c-4.3-11.2-6.7-23.5-6.9-36.1c-0.5-26.9,18.5-60.4,43.3-62.1c-22.1,29.8-16.6,56.3,3,69.2c34.4,22.6,77.7,1.3,87.2-36.6c11.6-46.4-40.5-77.7-74.9-71.6C-197-46-144.3,3-143.2,58.8c0.6,31.9-10.7,60.5-29,79.4C-202.9,163.6-243.3,167-274.9,138.5" />
        </g>
        <g className={styles.plumBody} transform="translate(415.8191 363.9603)">
          <path d="M-254.3,176.1c-56.6,0-102.4-46.1-102.4-103.1c0-51.8,39.1-92.9,88.5-95.2c-63.6-18.2-124.7,40.6-122.1,99.2c2.2,50.3,36.7,85.6,85.2,97.6c16.4,4,39.5,4.2,55.6,1.4C-251,176.1-252.6,176.1-254.3,176.1" />
        </g>
        <g className={styles.plumLeaves} transform="translate(413.6473 430.0902)">
          <path d="M-259.3-110.2c26.8-39.9,58.5-44.9,58.5-44.9c-26,11.7-42.5,34-52.2,51.3c61,3.8,65.2-27.3,78.1-48.4c12.9-21.1,33.3-13.7,33.3-13.7C-241.9-212.1-264.3-130.8-259.3-110.2" />
        </g>
        <g className={styles.plumLeaves} transform="translate(411.6446 432.2401)">
          <path d="M-264-119.5c-36-22.1-62.7-15.1-62.7-15.1c24.8,0.2,46.1,12,60.2,22.2c-46.4,24-61.4,1.1-79.4-11c-18-12.1-31.3,0.7-31.3,0.7C-315.8-193.5-267.8-137.4-264-119.5" />
        </g>
      </svg>
      <span className={styles.text}>
        PLUM<span className={styles.textX}>X</span>
      </span>
    </span>
  );
};

export default PlumXLogo;
